/** Findings and console-lock requests deliberately use different cache shapes. */
export const ONBOARDING_VIEWS = [
  'identity',
  'products',
  'competitors',
  'features',
  'criteria',
  'personas',
  'topics',
  'library',
] as const;

export type OnboardingView = (typeof ONBOARDING_VIEWS)[number];
export type FoundationSetupView = Extract<OnboardingView, 'products' | 'competitors' | 'personas'>;

export const onboardingKey = (workspaceId: string | undefined, view?: string | null): readonly unknown[] =>
  view ? ['onboarding', workspaceId ?? '', view] : ['onboarding', workspaceId ?? ''];

export const onboardingLockKey = (workspaceId: string | undefined): readonly unknown[] => [
  'onboarding-lock',
  workspaceId ?? '',
];

export function onboardingPath(
  workspaceId: string | undefined,
  options: { view?: string | null; items?: boolean } = {},
): string {
  const params = new URLSearchParams();
  if (options.view) params.set('view', options.view);
  if (options.items === false) params.set('items', 'false');
  const query = params.toString();
  return `/workspaces/${workspaceId}/onboarding${query ? `?${query}` : ''}`;
}

/** Accept only real setup steps; arbitrary query strings never reach the API. */
export function onboardingViewFromSearch(params: URLSearchParams): OnboardingView | null {
  const requested = params.get('view');
  return ONBOARDING_VIEWS.find((view) => view === requested) ?? null;
}

/** Stable deep link used by read-only identity rosters. */
export function onboardingEditorPath(view: FoundationSetupView): string {
  return `/onboarding?view=${encodeURIComponent(view)}`;
}
